var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.126,
    height: 21.126,
    viewBox: "0 0 21.126 21.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11563",
    "data-name": "Group 11563",
    transform: "translate(-466.5 -1412.937)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(467 1414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close-circle",
    "data-name": "Icon ionic-ios-close-circle",
    d: "M13.938,3.375A10.563,10.563,0,1,0,24.5,13.938,10.561,10.561,0,0,0,13.938,3.375Zm2.676,14.387-2.676-2.676-2.676,2.676a.812.812,0,1,1-1.148-1.148l2.676-2.676-2.676-2.676a.812.812,0,0,1,1.148-1.148l2.676,2.676,2.676-2.676a.812.812,0,1,1,1.148,1.148l-2.676,2.676,2.676,2.676a.815.815,0,0,1,0,1.148A.806.806,0,0,1,16.614,17.762Z",
    transform: "translate(463.125 1409.562)",
    fill: "#ff5d5d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcClose);
export default __webpack_public_path__ + "static/media/ac_close.30a4388f371da090958e216eef206663.svg";
export { ForwardRef as ReactComponent };